import React, { useState, useEffect, useRef  } from 'react';
import './../../App.css';
import './Sidebar.css';
import { SidebarDataMenu } from './SidebarData';
import { SidebarDataOthers } from './SidebarData';
// import { isBenby } from './../Security';
// icons
// import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function Sidebar({ user, userAccess, isHideSideMenu, setIsHideSideMenu}) {
  const [showHideButton, setShowHideButton] = useState(window.innerWidth > 900);
  const sidebarHolderRef = useRef(null);
  const sideBarHideRef = useRef(null);

  const slideBarHandleClick = () =>{
    setIsHideSideMenu(!isHideSideMenu);
  }

  useEffect(() => {
    const handleResize = () => {
        setShowHideButton(window.innerWidth > 900);
    };

    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div>
      <div className="SidebarContainer">
        <div ref={sidebarHolderRef} id="sidebarHolder" className={`SidebarHolder ${isHideSideMenu ? 'sideBar-hidden' : showHideButton ? 'sideBar-show' : ''}`} >
          <div id="sidebarTitle" className="SidebarTitle row" onClick={() => {window.location.pathname = "/"}}>
            {/* <div className="icon" onClick={() => {window.location.pathname = "/"}}><RequestQuoteIcon /></div> */}
            <div className="icon" onClick={() => {window.location.pathname = "/"}}><img alt="" src='logo/logo.png'></img></div>
            <div className="title" onClick={() => {window.location.pathname = "/"}}>PAYROLL SYSTEM</div>
            <div className="closeMenu" onClick={(event) => {event.stopPropagation(); CloseMenu()}}><CloseIcon/></div>
            { showHideButton &&
              <div className='sideBarHide' ref={sideBarHideRef} onClick={(event) => {event.stopPropagation(); slideBarHandleClick()}}>
                <ArrowBackIcon/>
              </div>
            }
          </div>

          {/* { showHideButton &&
            <div className='sideBarHide' ref={sideBarHideRef} onClick={() => slideBarHandleClick()}>
              <ArrowBackIcon/>
            </div>
          } */}
          
          {/* Menu Sect */}
          {/* {
            (userAccess?.hasMaintenance || userAccess?.hasCalendar || userAccess?.hasUser) ?
            (
              <div id="sidebar" className="Sidebar">
                <div className="SidebarMenu">MENU</div>
                <ul className="SidebarList">
                  {SidebarDataMenu.map((val, key) => {
                    return (
                      ShowMainMenu( val,key,userAccess, user)
                    )
                  })}
                </ul>
                <div className="SidebarMenu">Others</div>
                <ul className="SidebarList">
                  {SidebarDataOthers.map((val, key) => {
                    console.log("TEST")
                    return (
                      ShowMainMenu( val,key,userAccess, user)
                    )
                  })}
                </ul>
              </div>
            )
            :
            (
              <div id="sidebar" className="Sidebar">
                <div className="SidebarMenu">MENU</div>
                <ul className="SidebarList">
                  {SidebarDataMenu.map((val, key) => {
                    return (
                      ShowMainMenu( val,key,userAccess, user)
                    )
                  })}
                </ul>
              </div>
            )
          } */}

          <div id="sidebar" className="Sidebar">
            <div className="SidebarMenu">MENU</div>
            <ul className="SidebarList">
              {SidebarDataMenu.map((val, key) => {
                return (
                  ShowMainMenu( val,key,userAccess, user)
                )
              })}
            </ul>
            <div className="SidebarMenu">Others</div>
            <ul className="SidebarList">
              {SidebarDataOthers.map((val, key) => {
                return (
                  ShowMainMenu( val,key,userAccess, user)
                )
              })}
            </ul>
          </div>
        </div>


        { isHideSideMenu && showHideButton &&
          <div className='sideBarShow' onClick={() => slideBarHandleClick()}>
            <ArrowForwardIcon style={{marginLeft: "10px"}}/>
          </div>
        }

        {/* ------------- */}
        <div 
          id="menuSlide" 
          className="HamburgerMenu"
        >
          <div 
            className="icon"
            onClick={()=>ShowMenu()}
            >
              <MenuIcon />
          </div>
        </div>
      </div>
    </div>
  );
}

function ShowMenu() {
  var sidebarHolder = document.getElementById("sidebarHolder");

  if(sidebarHolder === null){
    sidebarHolder = document.getElementById("sidebarHolder-close");
  }

  var sidebar = document.getElementById("sidebar");
  var sidebarTitle = document.getElementById("sidebarTitle");
  var hamburgerMenu = document.getElementById("menuSlide");

  hamburgerMenu.id = "menuSlide-active";
  sidebar.id = "sidebar-active";
  sidebarTitle.id = "sidebarTitle-active";
  sidebarHolder.id = "sidebarHolder-active";
}

function CloseMenu() {
  var sidebarHolder = document.getElementById("sidebarHolder-active");
  var sidebar = document.getElementById("sidebar-active");
  var sidebarTitle = document.getElementById("sidebarTitle-active");
  var hamburgerMenu = document.getElementById("menuSlide-active");

  hamburgerMenu.id = "menuSlide";
  sidebar.id = "sidebar";
  sidebarTitle.id = "sidebarTitle";
  sidebarHolder.id = "sidebarHolder-close";
}

export const HideMenuFromTopBar = function(){
  var hamburgerMenu = document.getElementById("menuSlide");
  hamburgerMenu.id = "menuSlide-active";
}

function ShowMainMenu( val, key, userAccess, user){
  const [mainteActive, setMainteActive] = useState(
    window.location.pathname.startsWith('/payType') ||
    window.location.pathname.startsWith('/holiday') ||
    window.location.pathname.startsWith('/holidayType') ||
    window.location.pathname.startsWith('/leaveTypes') ||
    window.location.pathname.startsWith('/department') ||
    window.location.pathname.startsWith('/section') ||
    window.location.pathname.startsWith('/classification') ||
    window.location.pathname.startsWith('/payrollPeriod') ||
    window.location.pathname.startsWith('/company') ||
    window.location.pathname.startsWith('/position') ||
    window.location.pathname.startsWith('/paymentMethod') ||
    window.location.pathname.startsWith('/employeeStatus') ||
    window.location.pathname.startsWith('/jobTitle') ||
    window.location.pathname.startsWith('/employeeGroup1') ||
    window.location.pathname.startsWith('/employeeGroup2') ||
    window.location.pathname.startsWith('/announcement') ||
    window.location.pathname.startsWith('/timeKeeper') ||
    window.location.pathname.startsWith('/plantilya') ||
    window.location.pathname.startsWith('/costCenter') ||
    window.location.pathname.startsWith('/payrollJournalAccount') ||
    window.location.pathname.startsWith('/dtrRulesConfiguration') ||
    window.location.pathname.startsWith('/location')
  );
  const [transacActive, setTransacActive] = useState(
    window.location.pathname.startsWith('/dtr') ||
    window.location.pathname.startsWith('/dtrBiometrics') ||
    window.location.pathname.startsWith('/dtrWithOTViewing') ||
    window.location.pathname.startsWith('/offsetCredits') ||
    window.location.pathname.startsWith('/offsetRequest') ||
    window.location.pathname.startsWith('/officialBusiness') ||
    window.location.pathname.startsWith('/mobileDTRApproval') ||
    window.location.pathname.startsWith('/approverHierarchy') ||
    window.location.pathname.startsWith('/approverHierarchyPerLocation') ||
    window.location.pathname.startsWith('/requestApproval') ||
    window.location.pathname.startsWith('/requestApprovalTimeKeeper') ||
    window.location.pathname.startsWith('/massApproval') ||
    window.location.pathname.startsWith('/dtrAdjustmentWorkers') ||
    window.location.pathname.startsWith('/overtime') ||
    window.location.pathname.startsWith('/dtrAdjustment') ||
    window.location.pathname.startsWith('/leave') ||
    window.location.pathname.startsWith('/changeOfSchedule')
  );
  const [employeeTabActive, setEmployeeTabActive] = useState(
    window.location.pathname.startsWith('/addEmployee') ||
    window.location.pathname.startsWith('/employeeList') ||
    window.location.pathname.startsWith('/employmentStatus') ||
    window.location.pathname.startsWith('/employeeMonthlySalary') ||
    window.location.pathname.startsWith('/employeeDailySalary') ||
    window.location.pathname.startsWith('/positionDesignationSalary') ||
    window.location.pathname.startsWith('/employeeBankAccount') ||
    window.location.pathname.startsWith('/position') ||
    window.location.pathname.startsWith('/jobTitle') ||
    window.location.pathname.startsWith('/location') ||
    window.location.pathname.startsWith('/shiftSchedule')
  );
  const [reportsTabActive, setReportsTabActive] = useState(
    window.location.pathname.startsWith('/payslip') ||
    window.location.pathname.startsWith('/payrollRegister') ||
    window.location.pathname.startsWith('/payrollHistory') ||
    window.location.pathname.startsWith('/resigned') ||
    window.location.pathname.startsWith('/activeEmployees') ||
    window.location.pathname.startsWith('/yearOfService') ||
    window.location.pathname.startsWith('/sss-report') ||
    window.location.pathname.startsWith('/pagibig-report') ||
    window.location.pathname.startsWith('/philhealth-report') ||
    window.location.pathname.startsWith('/sssLoan-report') || 
    window.location.pathname.startsWith('/pagibigLoan-report') ||
    window.location.pathname.startsWith('/attendanceReport') ||
    window.location.pathname.startsWith('/bankTransmittalBPI') ||
    window.location.pathname.startsWith('/bankTransmittalBDO') ||
    window.location.pathname.startsWith('/bankTransmittalChinaBankSavings') ||
    window.location.pathname.startsWith('/bankTransmittalHSBC') ||
    window.location.pathname.startsWith('/bankTransmittalSecurityBank') ||
    window.location.pathname.startsWith('/summaryOfTardiness') ||
    window.location.pathname.startsWith('/absencesMemo') ||
    window.location.pathname.startsWith('/absencesReport') ||
    window.location.pathname.startsWith('/actionHistoryReport') ||
    window.location.pathname.startsWith('/allowanceSummary') ||
    window.location.pathname.startsWith('/basicPayAdjustmentReport') ||
    window.location.pathname.startsWith('/auditTrailReportEmployeeSetup') ||
    window.location.pathname.startsWith('/bundyClockUsage') ||
    window.location.pathname.startsWith('/certificateOfEmployment') ||
    window.location.pathname.startsWith('/certificateOfPagibig') ||
    window.location.pathname.startsWith('/certificateOfPhilhealth') ||
    window.location.pathname.startsWith('/certificateOfSSS') ||
    window.location.pathname.startsWith('/commissionsSummary') ||
    window.location.pathname.startsWith('/costCenterReport') ||
    window.location.pathname.startsWith('/deductionsPerMonth') ||
    window.location.pathname.startsWith('/dtrReport') ||
    window.location.pathname.startsWith('/earningsPerMonth') ||
    window.location.pathname.startsWith('/employeeLeaveGroup') ||
    window.location.pathname.startsWith('/employeeOvertimeGroup') ||
    window.location.pathname.startsWith('/employeeExpenseGroup') ||
    window.location.pathname.startsWith('/employeeLeaveHistory') ||
    window.location.pathname.startsWith('/employeeListingByHiringDate') ||
    window.location.pathname.startsWith('/employeeRegister') ||
    window.location.pathname.startsWith('/expenseReport') ||
    window.location.pathname.startsWith('/overtimeSummaryReport') ||
    window.location.pathname.startsWith('/perDayTracker') ||
    window.location.pathname.startsWith('/trackerReport') ||
    window.location.pathname.startsWith('/governmentEmployeeInventory') ||
    window.location.pathname.startsWith('/headcountReport') ||
    window.location.pathname.startsWith('/holidayPremiumSummary') ||
    window.location.pathname.startsWith('/leaveLedgerReport') ||
    window.location.pathname.startsWith('/leaveSummaryReport') ||
    window.location.pathname.startsWith('/loanHistory') ||
    window.location.pathname.startsWith('/loanPaymentsSummary') ||
    window.location.pathname.startsWith('/loansMonthlyAmmortizationSummary') ||
    window.location.pathname.startsWith('/loansPenaltyHistory') ||
    window.location.pathname.startsWith('/nightDifferentialSummary') ||
    window.location.pathname.startsWith('/nonTaxableAllowancesReport') ||
    window.location.pathname.startsWith('/otherEarningsReport') ||
    window.location.pathname.startsWith('/otherDeductionsSummary') ||
    window.location.pathname.startsWith('/outstandingLoans') ||
    window.location.pathname.startsWith('/payrollCashRegister') ||
    window.location.pathname.startsWith('/payrollCheckRegister') ||
    window.location.pathname.startsWith('/payrollDebitMemo') ||
    window.location.pathname.startsWith('/payrollJournalByCostCenter') ||
    window.location.pathname.startsWith('/payrollJournalByDepartment') ||
    window.location.pathname.startsWith('/payrollJournalBySummary') ||
    window.location.pathname.startsWith('/payrollPerPaymentMethod') ||
    window.location.pathname.startsWith('/selectLogs') ||
    window.location.pathname.startsWith('/summaryReportByMonthAndDepartment') ||
    window.location.pathname.startsWith('/tardinessMemo') ||
    window.location.pathname.startsWith('/timeKeepingHistoryDetailedReport') ||
    window.location.pathname.startsWith('/timeKeepingHoursWorkedReport') ||
    window.location.pathname.startsWith('/timeKeepingHoursWorkedSummary') ||
    window.location.pathname.startsWith('/timeKeepingReport') ||
    window.location.pathname.startsWith('/timesheetStatusReport') ||
    window.location.pathname.startsWith('/ytdDeductionSummary') ||
    window.location.pathname.startsWith('/ytdEarningsSummary') ||
    window.location.pathname.startsWith('/ytdPayrollRegister') ||
    window.location.pathname.startsWith('/BIR2316') ||
    window.location.pathname.startsWith('/BIR1601C') ||
    window.location.pathname.startsWith('/alphalist') ||
    window.location.pathname.startsWith('/loanReport') ||
    window.location.pathname.startsWith('/bankTransmittalReport') ||
    window.location.pathname.startsWith('/201report')
  );
  const [personnelTabActive, setPersonnelTabActive] = useState(
    window.location.pathname.startsWith('/addEmployee') ||
    window.location.pathname.startsWith('/employeeInformation') ||
    window.location.pathname.startsWith('/employeesList') ||
    window.location.pathname.startsWith('/employeeSchedule') ||
    window.location.pathname.startsWith('/uploadingSchedule') ||
    window.location.pathname.startsWith('/uploadedSchedule') ||
    window.location.pathname.startsWith('/employeeReliever') ||
    window.location.pathname.startsWith('/employeePagibig') ||
    window.location.pathname.startsWith('/employmentStatus')
  );
  const [timeKeepingTabActive, setTimeKeepingTabActive] = useState(
    window.location.pathname.startsWith('/timeKeeping') ||
    window.location.pathname.startsWith('/tamperedApproval') ||
    window.location.pathname.startsWith('/shiftSchedule')
  );
  const [payrollTabActive, setPayrollTabActive] = useState(
    window.location.pathname.startsWith('/payroll') ||
    window.location.pathname.startsWith('/thirteenthMonth') ||
    window.location.pathname.startsWith('/finalPay') ||
    window.location.pathname.startsWith('/subcon') ||
    window.location.pathname.startsWith('/agency') ||
    window.location.pathname.startsWith('/payrollPeriod')
  );
  const [govtTabActive, setGovtTabActive] = useState(
    window.location.pathname.startsWith('/tax') ||
    window.location.pathname.startsWith('/pagibig') ||
    window.location.pathname.startsWith('/sss') ||
    window.location.pathname.startsWith('/philhealth')
  );
  const [loansTabActive, setLoansTabActive] = useState(
    window.location.pathname.startsWith('/sssLoan') ||
    window.location.pathname.startsWith('/sssCalamityLoan') ||
    window.location.pathname.startsWith('/pagibigLoan') ||
    window.location.pathname.startsWith('/pagibigCalamityLoan') ||
    window.location.pathname.startsWith('/cashAdvance') ||
    window.location.pathname.startsWith('/loans') ||
    window.location.pathname.startsWith('/deductions') ||
    window.location.pathname.startsWith('/benefits')
  );
  
  if(val.title === "Maintenance"){
    const maintenancePaths = [
      '/payType',
      '/holiday',
      '/holidayType',
      '/leaveTypes',
      '/department',
      '/section',
      '/classification',
      '/company',
      '/position',
      '/paymentMethod',
      '/employeeStatus',
      '/jobTitle',
      '/employeeGroup1',
      '/employeeGroup2',
      '/dtrRulesConfiguration',
      '/location',
      '/timeKeeper',
      '/plantilya',
      '/costCenter',
      '/payrollJournalAccount',
      '/announcement',
    ];
    const isMaintenancePath = maintenancePaths.includes(window.location.pathname);

    const showSubmenu = (event) => {
      setMainteActive(true);
      event.currentTarget.children[1].id = "active-subMenu-maintenance";
      event.currentTarget.children[0].id = "active-menu-maintenance";
      SetDropdownIcon(true, "dropdown-icon-maintenance");
    }
  
    const closeSubmenu = (event) => {
      setMainteActive(false);
      event.currentTarget.children[1].id = "";
      event.currentTarget.children[0].id = "";
      SetDropdownIcon(false, "dropdown-icon-maintenance");
    }

    return(
      !userAccess?.hasPayType
      && !userAccess?.hasHoliday 
      && !userAccess?.hasHolidayType 
      && !userAccess?.hasLeaveType 
      && !userAccess?.hasDepartment 
      && !userAccess?.hasSection 
      && !userAccess?.hasClassification 
      && !userAccess?.hasCompany 
      && !userAccess?.hasPosition 
      && !userAccess?.hasPaymentMethod 
      && !userAccess?.hasJobTitle 
      && !userAccess?.hasEmployeeGroup1 
      && !userAccess?.hasEmployeeGroup2 
      && !userAccess?.hasLocation 
      && !userAccess?.hasDTRRulesConfiguration 
      && !userAccess?.hasTimeKeeper 
      && !userAccess?.hasPlantilya 
      && !userAccess?.hasCostCenter 
      && !userAccess?.hasPayrollJournalAccount 
      ?
        <div></div>
      :
        <div 
          onClick={(event)=>(mainteActive ? closeSubmenu(event) : showSubmenu(event))}>
          <li 
            key={key}
            className="SidebarRow row"
            id={isMaintenancePath ? "active-menu-maintenance" : ""}
          > 
            <div id="icon">{val.icon}</div> 
            <div id="title">{val.title}</div>
            <div>
              {isMaintenancePath ? (
                <KeyboardArrowUpIcon id={"dropdown-icon-maintenance"} />
              ) : (
                <KeyboardArrowDownIcon id={"dropdown-icon-maintenance"} />
              )}
            </div>
          </li>
          <div id={isMaintenancePath ? "active-subMenu-maintenance" : ""} className="mainte-subMenu" onClick={(event) => event.stopPropagation()}>
            {val.children.map((child) => {
              let isDisabled = false;

              if (child.name === "Pay Type" && !userAccess?.hasPayType) {
                isDisabled = true;
              }
              if (child.name === "Holiday" && !userAccess?.hasHoliday) {
                isDisabled = true;
              }
              if (child.name === "Holiday Type" && !userAccess?.hasHolidayType) {
                isDisabled = true;
              }
              if (child.name === "Leave Types" && !userAccess?.hasLeaveType) {
                isDisabled = true;
              }
              if (child.name === "Department" && !userAccess?.hasDepartment) {
                isDisabled = true;
              }
              if (child.name === "Section" && !userAccess?.hasSection) {
                isDisabled = true;
              }
              if (child.name === "Classification" && !userAccess?.hasClassification) {
                isDisabled = true;
              }
              if (child.name === "Company" && !userAccess?.hasCompany) {
                isDisabled = true;
              }
              if (child.name === "Position" && !userAccess?.hasPosition) {
                isDisabled = true;
              }
              if (child.name === "Payment Method" && !userAccess?.hasPaymentMethod) {
                isDisabled = true;
              }
              if (child.name === "Employee Status" && !userAccess?.hasJobTitle) {
                isDisabled = true;
              }
              if (child.name === "Job Title" && !userAccess?.hasJobTitle) {
                isDisabled = true;
              }
              if (child.name === "Employee Group 1" && !userAccess?.hasEmployeeGroup1) {
                isDisabled = true;
              }
              if (child.name === "Employee Group 1" && !userAccess?.hasEmployeeGroup2) {
                isDisabled = true;
              }
              if (child.name === "Location" && !userAccess?.hasLocation) {
                isDisabled = true;
              }
              if (child.name === "DTR Rules Configuration" && !userAccess?.hasDTRRulesConfiguration) {
                isDisabled = true;
              }
              if (child.name === "Time Keeper" && !userAccess?.hasTimeKeeper) {
                isDisabled = true;
              }
              if (child.name === "Plantilla" && !userAccess?.hasPlantilya) {
                isDisabled = true;
              }
              if (child.name === "Cost Center" && !userAccess?.hasCostCenter) {
                isDisabled = true;
              }
              if (child.name === "Payroll Journal Account" && !userAccess?.hasPayrollJournalAccount) {
                isDisabled = true;
              }
              if (child.name === "Announcement" && !userAccess?.hasLocation) {
                isDisabled = true;
              }

              return (
                <ul 
                  key={child.link}
                  id={window.location.pathname === child.link ? "active-ul" : ""}
                  onClick={() => window.location.pathname = child.link}
                  style={{display: isDisabled ? "none" : "block"}}
                >
                  <span>- {child.name}</span>
                </ul>
              );
            })}
          </div>
        </div> 
      ) 
  } else if(val.title === "Transactions"){
    const transactionPaths = [
      '/dtr',
      '/dtrBiometrics',
      '/dtrWithOTViewing',
      '/offsetCredits',
      '/offsetRequest',
      '/officialBusiness',
      '/mobileDTRApproval',
      '/approverHierarchy',
      '/approverHierarchyPerLocation',
      '/requestApproval',
      '/requestApprovalTimeKeeper',
      '/massApproval',
      '/dtrAdjustmentWorkers',
      '/overtime',
      '/dtrAdjustment',
      '/leave',
      '/changeOfSchedule',
    ];
    const isTransactionPaths = transactionPaths.includes(window.location.pathname);

    const showSubmenu = (event) => {
      setTransacActive(true);
      event.currentTarget.children[1].id = "active-subMenu-transaction";
      event.currentTarget.children[0].id = "active-menu-transaction";
      SetDropdownIcon(true, "dropdown-icon-transaction");
    }
  
    const closeSubmenu = (event) => {
      setTransacActive(false);
      event.currentTarget.children[1].id = "";
      event.currentTarget.children[0].id = "";
      SetDropdownIcon(false, "dropdown-icon-transaction");
    }
    
    return(
      !userAccess?.hasDTR
      && !userAccess?.hasDTRBiometrics 
      && !userAccess?.hasDTRWithOTViewing 
      && !userAccess?.hasMobileDTRApproval 
      && !userAccess?.hasDTRCorrectionWorkers 
      && !userAccess?.hasOffsetCredits 
      && !userAccess?.hasOffsetRequest 
      && !userAccess?.hasOfficialBusiness 
      && !userAccess?.hasApproverHierarchy 
      && !userAccess?.hasApproverheirarchyperlocation 
      && !userAccess?.hasRequestApproval 
      && !userAccess?.hasRequestApprovalTimeKeeper 
      && !userAccess?.hasOvertime 
      && !userAccess?.hasDTRCorrection 
      && !userAccess?.hasLeave 
      && !userAccess?.hasChangeOfSchedule 
      && !userAccess?.hasMassapproval 
      ?
        <div></div>
      :
        <div 
          onClick={(event)=>(transacActive ? closeSubmenu(event) : showSubmenu(event))}>
          <li 
            key={key}
            className="SidebarRow row"
            id={isTransactionPaths ? "active-menu-transaction" : ""}
          > 
            <div id="icon">{val.icon}</div> 
            <div id="title">{val.title}</div>
            <div>
              {isTransactionPaths ? (
                <KeyboardArrowUpIcon id={"dropdown-icon-transaction"} />
              ) : (
                <KeyboardArrowDownIcon id={"dropdown-icon-transaction"} />
              )}
            </div>
          </li>
          <div id={isTransactionPaths ? "active-subMenu-transaction" : ""} className="mainte-subMenu" onClick={(event) => event.stopPropagation()}>
            {val.children.map((child) => {
              let isDisabled = false;
              
              if (child.name === "DTR" && !userAccess?.hasDTR) {
                isDisabled = true;
              } 
              if (child.name === "DTR (Admin's View)" && !userAccess?.hasDTR) {
                isDisabled = true;
              } 
              if (child.name === "DTR (Employee's View)" && !userAccess?.hasDTRBiometrics) {
                isDisabled = true;
              } 
              if (child.name === "Mobile DTR Approval" && !userAccess?.hasMobileDTRApproval) {
                isDisabled = true;
              } 
              if (child.name === "DTR With OT Viewing" && !userAccess?.hasDTRWithOTViewing) {
                isDisabled = true;
              } 
              if (child.name === "Offset Credits" && !userAccess?.hasOffsetCredits /* user?.employeePersonalInformationEmployeeInformationSalaryType !== "Monthly" */ ){
                isDisabled = true;
              } 
              /* else if (child.name === "Offset Credits"){
                if(userAccess.description !== "Admin" 
                && userAccess.description !== "HR Head" 
                && userAccess.description !== "HR Assistant"
                && userAccess.description !== "HR Assistant2"
                && userAccess.description !== "HR Assistant3"
                && user?.employeePersonalInformationEmployeeInformationSalaryType !== "Monthly"
                ){
                  isDisabled = true;
                }
              } */

              if (child.name === "Offset Request" && !userAccess?.hasOffsetRequest) {
                isDisabled = true;
              } 
              /* else if (child.name === "Offset Request"){
                if(userAccess.description !== "Admin" 
                && userAccess.description !== "HR Head" 
                && userAccess.description !== "HR Assistant"
                && userAccess.description !== "HR Assistant2"
                && userAccess.description !== "HR Assistant3"
                && user?.employeePersonalInformationEmployeeInformationSalaryType !== "Monthly"
                ){
                  isDisabled = true;
                }
              } */
              
              if (child.name === "Official Business" && !userAccess?.hasOfficialBusiness) {
                isDisabled = true;
              }
              if (child.name === "Approver Hierarchy" && !userAccess?.hasApproverHierarchy) {
                isDisabled = true;
              }
              if (child.name === "Approver Hierarchy Per Location" && !userAccess?.hasApproverheirarchyperlocation) {
                isDisabled = true;
              }
              if (child.name === "Request Approval" && !userAccess?.hasRequestApproval) {
                isDisabled = true;
              }
              if (child.name === "Request Approval Time Keeper" && !userAccess?.hasRequestApprovalTimeKeeper) {
                isDisabled = true;
              }
              if (child.name === "Mass Approval" && !userAccess?.hasMassapproval) {
                isDisabled = true;
              }
              if (child.name === "DTR Adjustment Workers" && !userAccess?.hasDTRCorrectionWorkers) {
                isDisabled = true;
              }
              if (child.name === "Overtime" && !userAccess?.hasOvertime) {
                isDisabled = true;
              }
              if (child.name === "DTR Adjustment" && !userAccess?.hasDTRCorrection) {
                isDisabled = true;
              }
              if (child.name === "Leave" && !userAccess?.hasLeave) {
                isDisabled = true;
              }
              if (child.name === "Change of Schedule" && !userAccess?.hasChangeOfSchedule) {
                isDisabled = true;
              }

              return (
                <ul 
                  key={child.link}
                  id={window.location.pathname === child.link ? "active-ul" : ""}
                  onClick={() => window.location.pathname = child.link}
                  style={{display: isDisabled ? "none" : "block"}}
                >
                  <span>- {child.name}</span>
                </ul>
              );
            })}
          </div>
        </div>
    )
  } else if(val.title === "Salary Module"){
    const employeesTabPath = [
      '/employeeMonthlySalary',
      '/employeeDailySalary',
      '/positionDesignationSalary',
      '/employeeBankAccount',
    ];
    const isEmployeesTabPaths = employeesTabPath.includes(window.location.pathname);

    const showSubmenu = (event) => {
      setEmployeeTabActive(true);
      event.currentTarget.children[1].id = "active-subMenu-employeesTab";
      event.currentTarget.children[0].id = "active-menu-employeesTab";
      SetDropdownIcon(true, "dropdown-icon-employeesTab");
    }
  
    const closeSubmenu = (event) => {
      setEmployeeTabActive(false);
      event.currentTarget.children[1].id = "";
      event.currentTarget.children[0].id = "";
      SetDropdownIcon(false, "dropdown-icon-employeesTab");
    }

    return(
      !userAccess?.hasEmployeeMonthlySalary
      && !userAccess?.hasEmployeeDailySalary 
      && !userAccess?.hasPositionDesignationSalary 
      && !userAccess?.hasEmployeeBankAccount 
      ?
        <div></div>
      :
        <div 
          onClick={(event)=>(employeeTabActive ? closeSubmenu(event) : showSubmenu(event))}>
          <li 
            key={key}
            className="SidebarRow row"
            id={isEmployeesTabPaths ? "active-menu-employeesTab" : ""}
          > 
            <div id="icon">{val.icon}</div> 
            <div id="title">{val.title}</div>
            <div>
              {isEmployeesTabPaths ? (
                <KeyboardArrowUpIcon id={"dropdown-icon-employeesTab"} />
              ) : (
                <KeyboardArrowDownIcon id={"dropdown-icon-employeesTab"} />
              )}
            </div>
          </li>
          <div id={isEmployeesTabPaths ? "active-subMenu-employeesTab" : ""} className="mainte-subMenu" onClick={(event) => event.stopPropagation()}>
          {val.children.map((child) => {
            let isDisabled = false;
            
            if (child.name === "Employee Monthly Salary" && !userAccess?.hasEmployeeMonthlySalary) {
              isDisabled = true;
            } 
            if (child.name === "Employee Daily Salary" && !userAccess?.hasEmployeeDailySalary) {
              isDisabled = true;
            } 
            if (child.name === "Position - Designation Salary" && !userAccess?.hasPositionDesignationSalary) {
              isDisabled = true;
            }
            if (child.name === "Employee Bank Account" && !userAccess?.hasEmployeeBankAccount) {
              isDisabled = true;
            }

            return (
              <ul 
                key={child.link}
                id={window.location.pathname === child.link ? "active-ul" : ""}
                onClick={() => window.location.pathname = child.link}
                style={{display: isDisabled ? "none" : "block"}}
              >
                <span>- {child.name}</span>
              </ul>
            );
          })}
          </div>
        </div>
      )
  } else if(val.title === "Reports"){
    const reportsPath = [
      '/payslip',
      '/payrollRegister',
      '/payrollHistory',
      '/resigned',
      '/activeEmployees',
      '/yearOfService',
      '/sss-report',
      '/pagibig-report',
      '/philhealth-report',
      '/sssLoan-report',
      '/pagibigLoan-report',
      '/201report',
      '/auditTrailReportEmployeeSetup',
      '/attendanceReport',
      '/bankTransmittalBPI',
      '/bankTransmittalBDO',
      '/bankTransmittalChinaBankSavings',
      '/bankTransmittalHSBC',
      '/bankTransmittalSecurityBank',
      '/summaryOfTardiness',
      '/absencesMemo',
      '/absencesReport',
      '/actionHistoryReport',
      '/allowanceSummary',
      '/bundyClockUsage',
      '/basicPayAdjustmentReport',
      '/certificateOfEmployment',
      '/certificateOfPagibig',
      '/certificateOfPhilhealth',
      '/certificateOfSSS',
      '/commissionsSummary',
      '/costCenterReport',
      '/deductionsPerMonth',
      '/dtrReport',
      '/earningsPerMonth',
      '/employeeLeaveGroup',
      '/employeeOvertimeGroup',
      '/employeeExpenseGroup',
      '/employeeLeaveHistory',
      '/employeeListingByHiringDate',
      '/employeeRegister',
      '/expenseReport',
      '/overtimeSummaryReport',
      '/perDayTracker',
      '/trackerReport',
      '/governmentEmployeeInventory',
      '/headcountReport',
      '/holidayPremiumSummary',
      '/leaveLedgerReport',
      '/leaveSummaryReport',
      '/loanHistory',
      '/loanPaymentsSummary',
      '/loansMonthlyAmmortizationSummary',
      '/loansPenaltyHistory',
      '/nightDifferentialSummary',
      '/nonTaxableAllowancesReport',
      '/otherEarningsReport',
      '/otherDeductionsSummary',
      '/outstandingLoans',
      '/payrollCashRegister',
      '/payrollCheckRegister',
      '/payrollDebitMemo',
      '/payrollJournalByCostCenter',
      '/payrollJournalByDepartment',
      '/payrollJournalBySummary',
      '/payrollPerPaymentMethod',
      '/selectLogs',
      '/summaryReportByMonthAndDepartment',
      '/tardinessMemo',
      '/timeKeepingHistoryDetailedReport',
      '/timeKeepingHoursWorkedReport',
      '/timeKeepingHoursWorkedSummary',
      '/timeKeepingReport',
      '/timesheetStatusReport',
      '/ytdDeductionSummary',
      '/ytdEarningsSummary',
      '/ytdPayrollRegister',
      '/BIR2316',
      '/BIR1601C',
      '/alphalist',
      '/loanReport',
      '/bankTransmittalReport',
    ];
    const isReportsPath = reportsPath.includes(window.location.pathname);

    const showSubmenu = (event) => {
      setReportsTabActive(true);
      event.currentTarget.children[1].id = "active-subMenu-reports";
      event.currentTarget.children[0].id = "active-menu-reports";
      SetDropdownIcon(true, "dropdown-icon-reports");
    }
  
    const closeSubmenu = (event) => {
      setReportsTabActive(false);
      event.currentTarget.children[1].id = "";
      event.currentTarget.children[0].id = "";
      SetDropdownIcon(false, "dropdown-icon-reports");
    }

    return(
      !userAccess?.hasPerDayTracker
      && !userAccess?.hasOvertimeSummaryReport 
      && !userAccess?.hasTrackerReport 
      && !userAccess?.hasPayslip 
      && !userAccess?.hasPayrollRegister 
      && !userAccess?.hasResigned 
      && !userAccess?.hasActiveEmployees 
      && !userAccess?.hasYearofService 
      && !userAccess?.hasSSSSummary 
      && !userAccess?.hasPagibigSummary 
      && !userAccess?.hasPhilhealthSummary 
      && !userAccess?.hasSSSLoanReport 
      && !userAccess?.hasPagibigLoanReport 
      && !userAccess?.has201Report 
      && !userAccess?.hasAttendanceReport 
      && !userAccess?.hasBankTransmittalBDO 
      && !userAccess?.hasBankTransmittalBPI 
      && !userAccess?.hasBankTransmittalChinaBankSavings 
      && !userAccess?.hasBankTransmittalHSBC 
      && !userAccess?.hasBankTransmittalSecurityBank 
      && !userAccess?.hasSummaryOfTardiness 
      && !userAccess?.hasAbsencesMemo 
      && !userAccess?.hasAbsencesReport 
      && !userAccess?.hasActionHistoryReport 
      && !userAccess?.hasAllowanceSummary 
      && !userAccess?.hasAuditTrailReportEmployeeSetup 
      && !userAccess?.hasBundyClockUsage 
      && !userAccess?.hasBasicPayAdjustmentReport 
      && !userAccess?.hasCertificateOfEmployment 
      && !userAccess?.hasCertificateOfPagibig 
      && !userAccess?.hasCertificateOfPhilhealth 
      && !userAccess?.hasCertificateOfSSS 
      && !userAccess?.hasCommissionsSummary 
      && !userAccess?.hasCostCenterReport 
      && !userAccess?.hasDeductionsPerMonth 
      && !userAccess?.hasDTRReport 
      && !userAccess?.hasEarningsPerMonth 
      && !userAccess?.hasEmployeeLeaveGroup 
      && !userAccess?.hasEmployeeOvertimeGroup 
      && !userAccess?.hasEmployeeExpenseGroup 
      && !userAccess?.hasEmployeeLeaveHistory 
      && !userAccess?.hasEmployeeListingByHiringDate 
      && !userAccess?.hasEmployeeRegister 
      && !userAccess?.hasExpenseReport 
      && !userAccess?.hasGovernmentEmployeeInventory 
      && !userAccess?.hasHeadcountReport 
      && !userAccess?.hasHolidayPremiumSummary 
      && !userAccess?.hasLeaveLedgerReport 
      && !userAccess?.hasLeaveSummaryReport 
      && !userAccess?.hasLoanHistory 
      && !userAccess?.hasLoanPaymentsSummary 
      && !userAccess?.hasLoansMonthlyAmortizationSummary 
      && !userAccess?.hasLoansPenaltyHistory 
      && !userAccess?.hasNightDifferentialSummary 
      && !userAccess?.hasNonTaxableAllowancesReport 
      && !userAccess?.hasOtherEarningsReport 
      && !userAccess?.hasOtherDeductionsSummary 
      && !userAccess?.hasOutstandingLoans 
      && !userAccess?.hasPayrollCashRegister 
      && !userAccess?.hasPayrollCheckRegister 
      && !userAccess?.hasPayrollDebitMemo 
      && !userAccess?.hasPayrollJournalByCostCenter 
      && !userAccess?.hasPayrollJournalByDepartment 
      && !userAccess?.hasPayrollJournalBySummary 
      && !userAccess?.hasPayrollPerPaymentMethod 
      && !userAccess?.hasSelectLogs 
      && !userAccess?.hasSummaryReportByMonthAndDepartment 
      && !userAccess?.hasTardinessMemo 
      && !userAccess?.hasTimeKeepingHistoryDetailedReport 
      && !userAccess?.hasTimeKeepingHoursWorkedReport 
      && !userAccess?.hasTimeKeepingHoursWorkedSummary 
      && !userAccess?.hasTimeKeepingReport 
      && !userAccess?.hasTimesheetStatusReport 
      && !userAccess?.hasYTDDeductionSummary 
      && !userAccess?.hasYTDEarningsSummary 
      && !userAccess?.hasYTDPayrollRegister
      && !userAccess?.hasBIR2316
      && !userAccess?.hasBIR1601C
      && !userAccess?.hasAlphaList
      && !userAccess?.hasLoanReport
      && !userAccess?.hasBankTransmittalReport
      ?
        <div></div>
      :
        <div 
          onClick={(event)=>(reportsTabActive ? closeSubmenu(event) : showSubmenu(event))}>
          <li 
            key={key}
            className="SidebarRow row"
            id={isReportsPath ? "active-menu-reports" : ""}
          > 
            <div id="icon">{val.icon}</div> 
            <div id="title">{val.title}</div>
            <div>
              {isReportsPath ? (
                <KeyboardArrowUpIcon id={"dropdown-icon-reports"} />
              ) : (
                <KeyboardArrowDownIcon id={"dropdown-icon-reports"} />
              )}
            </div>
          </li>
          <div id={isReportsPath ? "active-subMenu-reports" : ""} className="mainte-subMenu" onClick={(event) => event.stopPropagation()}>
            {val.children.map((child) => {
              let isDisabled = false;
              
              if (child.name === "BIR Form No. 2316" && !userAccess?.hasBIR2316) {
                isDisabled = true;
              } 
              if (child.name === "BIR Form No. 1601C" && !userAccess?.hasBIR1601C) {
                isDisabled = true;
              } 
              if (child.name === "Alphalist" && !userAccess?.hasAlphaList) {
                isDisabled = true;
              } 
              if (child.name === "Bank Transmittal Report" && !userAccess?.hasBankTransmittalReport) {
                isDisabled = true;
              } 
              if (child.name === "Loan Report" && !userAccess?.hasLoanReport) {
                isDisabled = true;
              } 
              if (child.name === "Per Day Tracker" && !userAccess?.hasPerDayTracker) {
                isDisabled = true;
              } 
              if (child.name === "Overtime Summary Report" && !userAccess?.hasOvertimeSummaryReport ) {
                isDisabled = true;
              } 
              if (child.name === "Tracker Report" && !userAccess?.hasTrackerReport ) {
                isDisabled = true;
              }
              if (child.name === "Payslip" && !userAccess?.hasPayslip ) {
                isDisabled = true;
              }
              if (child.name === "Payroll Register" && !userAccess?.hasPayrollRegister) {
                isDisabled = true;
              } 
              if (child.name === "Resigned" && !userAccess?.hasResigned) {
                isDisabled = true;
              } 
              if (child.name === "Active Employees" && !userAccess?.hasActiveEmployees) {
                isDisabled = true;
              } 
              if (child.name === "Year of Service" && !userAccess?.hasYearofService) {
                isDisabled = true;
              } 
              if (child.name === "SSS Summary" && !userAccess?.hasSSSSummary) {
                isDisabled = true;
              } 
              if (child.name === "Pagibig Summary" && !userAccess?.hasPagibigSummary) {
                isDisabled = true;
              } 
              if (child.name === "Philhealth Summary" && !userAccess?.hasPhilhealthSummary) {
                isDisabled = true;
              } 
              if (child.name === "SSS Loan Report" && !userAccess?.hasSSSLoanReport) {
                isDisabled = true;
              } 
              if (child.name === "Pagibig Loan Report" && !userAccess?.hasPagibigLoanReport) {
                isDisabled = true;
              } 
              if (child.name === "201 Report" && !userAccess?.has201Report) {
                isDisabled = true;
              } 
              if (child.name === "Attendance Report" && !userAccess?.hasAttendanceReport) {
                isDisabled = true;
              } 
              if (child.name === "Bank Transmittal BDO" && !userAccess?.hasBankTransmittalBDO) {
                isDisabled = true;
              } 
              if (child.name === "Bank Transmittal BPI" && !userAccess?.hasBankTransmittalBPI) {
                isDisabled = true;
              } 
              if (child.name === "Bank Transmittal China Bank Savings" && !userAccess?.hasBankTransmittalChinaBankSavings) {
                isDisabled = true;
              } 
              if (child.name === "Bank Transmittal HSBC" && !userAccess?.hasBankTransmittalHSBC) {
                isDisabled = true;
              } 
              if (child.name === "Bank Transmittal Security Bank" && !userAccess?.hasBankTransmittalSecurityBank) {
                isDisabled = true;
              } 
              if (child.name === "Summary Of Tardiness" && !userAccess?.hasSummaryOfTardiness) {
                isDisabled = true;
              } 
              if (child.name === "Absences Memo" && !userAccess?.hasAbsencesMemo) {
                isDisabled = true;
              } 
              if (child.name === "Absences Report" && !userAccess?.hasAbsencesReport) {
                isDisabled = true;
              } 
              if (child.name === "Action History Report" && !userAccess?.hasActionHistoryReport) {
                isDisabled = true;
              } 
              if (child.name === "Allowance Summary" && !userAccess?.hasAllowanceSummary) {
                isDisabled = true;
              } 
              if (child.name === "Audit Trail Report - Employee Setup" && !userAccess?.hasAuditTrailReportEmployeeSetup) {
                isDisabled = true;
              } 
              if (child.name === "Bundy Clock Usage" && !userAccess?.hasBundyClockUsage) {
                isDisabled = true;
              } 
              if (child.name === "Basic Pay Adjustment Report" && !userAccess?.hasBasicPayAdjustmentReport) {
                isDisabled = true;
              } 
              if (child.name === "Certificate Of Employment" && !userAccess?.hasCertificateOfEmployment) {
                isDisabled = true;
              } 
              if (child.name === "Certificate Of Pagibig" && !userAccess?.hasCertificateOfPagibig) {
                isDisabled = true;
              } 
              if (child.name === "Certificate Of Philhealth" && !userAccess?.hasCertificateOfPhilhealth) {
                isDisabled = true;
              } 
              if (child.name === "Certificate Of SSS" && !userAccess?.hasCertificateOfSSS) {
                isDisabled = true;
              } 
              if (child.name === "Commissions Summary" && !userAccess?.hasCommissionsSummary) {
                isDisabled = true;
              } 
              if (child.name === "Cost Center Report" && !userAccess?.hasCostCenterReport) {
                isDisabled = true;
              } 
              if (child.name === "Deductions Per Month" && !userAccess?.hasDeductionsPerMonth) {
                isDisabled = true;
              } 
              if (child.name === "DTR Report" && !userAccess?.hasDTRReport) {
                isDisabled = true;
              } 
              if (child.name === "Earnings Per Month" && !userAccess?.hasEarningsPerMonth) {
                isDisabled = true;
              } 
              if (child.name === "Employee Leave Group" && !userAccess?.hasEmployeeLeaveGroup) {
                isDisabled = true;
              } 
              if (child.name === "Employee Overtime Group" && !userAccess?.hasEmployeeOvertimeGroup) {
                isDisabled = true;
              } 
              if (child.name === "Employee Expense Group" && !userAccess?.hasEmployeeExpenseGroup) {
                isDisabled = true;
              } 
              if (child.name === "Employee Leave History" && !userAccess?.hasEmployeeLeaveHistory) {
                isDisabled = true;
              } 
              if (child.name === "Employee Listing By Hiring Date" && !userAccess?.hasEmployeeListingByHiringDate) {
                isDisabled = true;
              } 
              if (child.name === "Employee Register" && !userAccess?.hasEmployeeRegister) {
                isDisabled = true;
              } 
              if (child.name === "Expense Report" && !userAccess?.hasExpenseReport) {
                isDisabled = true;
              } 
              if (child.name === "Government Employee Inventory" && !userAccess?.hasGovernmentEmployeeInventory) {
                isDisabled = true;
              } 
              if (child.name === "Headcount Report" && !userAccess?.hasHeadcountReport) {
                isDisabled = true;
              } 
              if (child.name === "Holiday Premium Summary" && !userAccess?.hasHolidayPremiumSummary) {
                isDisabled = true;
              } 
              if (child.name === "Leave Ledger Report" && !userAccess?.hasLeaveLedgerReport) {
                isDisabled = true;
              } 
              if (child.name === "Leave Summary Report" && !userAccess?.hasLeaveSummaryReport) {
                isDisabled = true;
              } 
              if (child.name === "Loan History" && !userAccess?.hasLoanHistory) {
                isDisabled = true;
              } 
              if (child.name === "Loan Payments Summary" && !userAccess?.hasLoanPaymentsSummary) {
                isDisabled = true;
              } 
              if (child.name === "Loans Monthly Amortization Summary" && !userAccess?.hasLoansMonthlyAmortizationSummary) {
                isDisabled = true;
              } 
              if (child.name === "Loans Penalty History" && !userAccess?.hasLoansPenaltyHistory) {
                isDisabled = true;
              } 
              if (child.name === "Night Differential Summary" && !userAccess?.hasNightDifferentialSummary) {
                isDisabled = true;
              } 
              if (child.name === "Non Taxable Allowances Report" && !userAccess?.hasNonTaxableAllowancesReport) {
                isDisabled = true;
              } 
              if (child.name === "Other Earnings Report" && !userAccess?.hasOtherEarningsReport) {
                isDisabled = true;
              } 
              if (child.name === "Other Deductions Summary" && !userAccess?.hasOtherDeductionsSummary) {
                isDisabled = true;
              } 
              if (child.name === "Outstanding Loans" && !userAccess?.hasOutstandingLoans) {
                isDisabled = true;
              } 
              if (child.name === "Payroll Cash Register" && !userAccess?.hasPayrollCashRegister) {
                isDisabled = true;
              } 
              if (child.name === "Payroll Check Register" && !userAccess?.hasPayrollCheckRegister) {
                isDisabled = true;
              } 
              if (child.name === "Payroll Debit Memo" && !userAccess?.hasPayrollDebitMemo) {
                isDisabled = true;
              } 
              if (child.name === "Payroll Journal By Cost Center" && !userAccess?.hasPayrollJournalByCostCenter) {
                isDisabled = true;
              } 
              if (child.name === "Payroll Journal By Department" && !userAccess?.hasPayrollJournalByDepartment) {
                isDisabled = true;
              } 
              if (child.name === "Payroll Journal By Summary" && !userAccess?.hasPayrollJournalBySummary) {
                isDisabled = true;
              } 
              if (child.name === "Payroll Per Payment Method" && !userAccess?.hasPayrollPerPaymentMethod) {
                isDisabled = true;
              } 
              if (child.name === "Select Logs" && !userAccess?.hasSelectLogs) {
                isDisabled = true;
              } 
              if (child.name === "Summary Report By Month And Department" && !userAccess?.hasSummaryReportByMonthAndDepartment) {
                isDisabled = true;
              } 
              if (child.name === "Tardiness Memo" && !userAccess?.hasTardinessMemo) {
                isDisabled = true;
              } 
              if (child.name === "Time Keeping History Detailed Report" && !userAccess?.hasTimeKeepingHistoryDetailedReport) {
                isDisabled = true;
              } 
              if (child.name === "Time Keeping Hours Worked Report" && !userAccess?.hasTimeKeepingHoursWorkedReport) {
                isDisabled = true;
              } 
              if (child.name === "Time Keeping Hours Worked Summary" && !userAccess?.hasTimeKeepingHoursWorkedSummary) {
                isDisabled = true;
              } 
              if (child.name === "Time Keeping Report" && !userAccess?.hasTimeKeepingReport) {
                isDisabled = true;
              } 
              if (child.name === "Timesheet Status Report" && !userAccess?.hasTimesheetStatusReport) {
                isDisabled = true;
              } 
              if (child.name === "YTD Deduction Summary" && !userAccess?.hasYTDDeductionSummary) {
                isDisabled = true;
              } 
              if (child.name === "YTD Earnings Summary" && !userAccess?.hasYTDEarningsSummary) {
                isDisabled = true;
              } 
              if (child.name === "YTD Payroll Register" && !userAccess?.hasYTDPayrollRegister) {
                isDisabled = true;
              } 

              return (
                <ul 
                  key={child.link}
                  id={window.location.pathname === child.link ? "active-ul" : ""}
                  onClick={() => window.location.pathname = child.link}
                  style={{display: isDisabled ? "none" : "block"}}
                >
                  <span>- {child.name}</span>
                </ul>
              );
            })}
          </div>
        </div>
    )
  } else if(val.title === "Personnel"){
    const personnelPath = [
      '/addEmployee',
      '/employeeInformation',
      '/employeesList',
      '/employmentStatus',
      '/employeeSchedule',
      '/uploadingSchedule',
      '/uploadedSchedule',
      '/employeeReliever',
      '/employeePagibig',
  
    ];
    const isPersonnelPath = personnelPath.includes(window.location.pathname);

    const showSubmenu = (event) => {
      setPersonnelTabActive(true);
      event.currentTarget.children[1].id = "active-subMenu-personnel";
      event.currentTarget.children[0].id = "active-menu-personnel";
      SetDropdownIcon(true, "dropdown-icon-personnel");
    }
  
    const closeSubmenu = (event) => {
      setPersonnelTabActive(false);
      event.currentTarget.children[1].id = "";
      event.currentTarget.children[0].id = "";
      SetDropdownIcon(false, "dropdown-icon-personnel");
    }

    return(
      !userAccess?.hasAddEmployee
      && !userAccess?.hasEmployeeList 
      && !userAccess?.hasEmploymentStatus 
      && !userAccess?.hasEmployeeSchedule 
      && !userAccess?.hasUploadingSchedule 
      && !userAccess?.hasUploadedSchedule 
      && !userAccess?.hasEmployeereliever 
      && !userAccess?.hasEmployeePagibig
      && userAccess?.description !== "Employee"
      ?
        <div></div>
      :
        <div 
          onClick={(event)=>(personnelTabActive ? closeSubmenu(event) : showSubmenu(event))}>
          <li 
            key={key}
            className="SidebarRow row"
            id={isPersonnelPath ? "active-menu-personnel" : ""}
          > 
            <div id="icon">{val.icon}</div> 
            <div id="title">{val.title}</div>
            <div>
              {isPersonnelPath ? (
                <KeyboardArrowUpIcon id={"dropdown-icon-personnel"} />
              ) : (
                <KeyboardArrowDownIcon id={"dropdown-icon-personnel"} />
              )}
            </div>
          </li>
          <div id={isPersonnelPath ? "active-subMenu-personnel" : ""} className="mainte-subMenu" onClick={(event) => event.stopPropagation()}>
          {val.children.map((child) => {
              let isDisabled = false;
              
              if (child.name === "Add Employee" && !userAccess?.hasAddEmployee) {
                isDisabled = true;
              } 
              if (child.name === "Employee List" && !userAccess?.hasEmployeeList) {
                isDisabled = true;
              }
              if (child.name === "Employee Information" && userAccess?.description !== "Employee") {
                isDisabled = true;
              }
              if (child.name === "Employee Reliever" && !userAccess?.hasEmployeereliever) {
                isDisabled = true;
              }
              if (child.name === "Employment Status" && !userAccess?.hasEmploymentStatus) {
                isDisabled = true;
              }
              if (child.name === "Employee Schedule" && !userAccess?.hasEmployeeSchedule) {
                isDisabled = true;
              }
              if (child.name === "Uploading Schedule" && !userAccess?.hasUploadingSchedule) {
                isDisabled = true;
              }
              if (child.name === "Uploaded Schedule" && !userAccess?.hasUploadedSchedule) {
                isDisabled = true;
              }
              if (child.name === "Employee Pagibig" && !userAccess?.hasEmployeePagibig) {
                isDisabled = true;
              }

              return (
                <ul 
                  key={child.link}
                  id={window.location.pathname === child.link ? "active-ul" : ""}
                  onClick={() => window.location.pathname = child.link}
                  style={{display: isDisabled ? "none" : "block"}}
                >
                  <span>- {child.name}</span>
                </ul>
              );
            })}
          </div>
        </div>
    )
  } else if(val.title === "Time Keeping"){
    const timeKeepingPath = [
      '/timeKeeping',
      '/tamperedApproval',
      '/shiftSchedule'
    ];
    const isTimeKeepingPath = timeKeepingPath.includes(window.location.pathname);

    const showSubmenu = (event) => {
      setTimeKeepingTabActive(true);
      event.currentTarget.children[1].id = "active-subMenu-timeKeeping";
      event.currentTarget.children[0].id = "active-menu-timeKeeping";
      SetDropdownIcon(true, "dropdown-icon-timeKeeping");
    }
  
    const closeSubmenu = (event) => {
      setTimeKeepingTabActive(false);
      event.currentTarget.children[1].id = "";
      event.currentTarget.children[0].id = "";
      SetDropdownIcon(false, "dropdown-icon-timeKeeping");
    }

    return(
      !userAccess?.hasTimeEntries
      && !userAccess?.hasTamperedApproval 
      && !userAccess?.hasShiftSchedule 
      ?
        <div></div>
      :
        <div 
          onClick={(event)=>(timeKeepingTabActive ? closeSubmenu(event) : showSubmenu(event))}>
          <li 
            key={key}
            className="SidebarRow row"
            id={isTimeKeepingPath ? "active-menu-timeKeeping" : ""}
          > 
            <div id="icon">{val.icon}</div> 
            <div id="title">{val.title}</div>
            <div>
              {isTimeKeepingPath ? (
                <KeyboardArrowUpIcon id={"dropdown-icon-timeKeeping"} />
              ) : (
                <KeyboardArrowDownIcon id={"dropdown-icon-timeKeeping"} />
              )}
            </div>
          </li>
          <div id={isTimeKeepingPath ? "active-subMenu-timeKeeping" : ""} className="mainte-subMenu" onClick={(event) => event.stopPropagation()}>
          {val.children.map((child) => {
              let isDisabled = false;
              
              if (child.name === "Time Entries" && !userAccess?.hasTimeEntries) {
                isDisabled = true;
              } 
              if (child.name === "Tampered Approval" && !userAccess?.hasTamperedApproval) {
                isDisabled = true;
              } 
              if (child.name === "Shift Schedule" && !userAccess?.hasShiftSchedule) {
                isDisabled = true;
              } 

              return (
                <ul 
                  key={child.link}
                  id={window.location.pathname === child.link ? "active-ul" : ""}
                  onClick={() => window.location.pathname = child.link}
                  style={{display: isDisabled ? "none" : "block"}}
                >
                  <span>- {child.name}</span>
                </ul>
              );
            })}
          </div>
        </div>
    )
  } else if(val.title === "Payroll"){
    const payrollPath = [
      '/payroll',
      '/thirteenthMonth',
      '/finalPay',
      '/subcon',
      '/agency',
      '/payrollPeriod'
    ];
    const isPayrollPath = payrollPath.includes(window.location.pathname);

    const showSubmenu = (event) => {
      setPayrollTabActive(true);
      event.currentTarget.children[1].id = "active-subMenu-payroll";
      event.currentTarget.children[0].id = "active-menu-payroll";
      SetDropdownIcon(true, "dropdown-icon-payroll");
    }
  
    const closeSubmenu = (event) => {
      setPayrollTabActive(false);
      event.currentTarget.children[1].id = "";
      event.currentTarget.children[0].id = "";
      SetDropdownIcon(false, "dropdown-icon-payroll");
    }

    return (
      !userAccess?.hasProcessPayroll
      && !userAccess?.hasPayrollPeriod 
      && !userAccess?.has13thMonth 
      && !userAccess?.hasFinalPay 
      && !userAccess?.hasSubcon 
      && !userAccess?.hasAgency 
      ?
        <div></div>
      :
        <div 
          onClick={(event)=>(payrollTabActive ? closeSubmenu(event) : showSubmenu(event))}>
          <li 
            key={key}
            className="SidebarRow row"
            id={isPayrollPath ? "active-menu-payroll" : ""}
          > 
            <div id="icon">{val.icon}</div> 
            <div id="title">{val.title}</div>
            <div>
              {isPayrollPath ? (
                <KeyboardArrowUpIcon id={"dropdown-icon-payroll"} />
              ) : (
                <KeyboardArrowDownIcon id={"dropdown-icon-payroll"} />
              )}
            </div>
          </li>
          <div id={isPayrollPath ? "active-subMenu-payroll" : ""} className="mainte-subMenu" onClick={(event) => event.stopPropagation()}>
          {val.children.map((child) => {
              let isDisabled = false;
              
              if (child.name === "Process Payroll" && !userAccess?.hasProcessPayroll) {
                isDisabled = true;
              } 
              if (child.name === "13th Month" && !userAccess?.has13thMonth) {
                isDisabled = true;
              } 
              if (child.name === "Final Pay" && !userAccess?.hasFinalPay) {
                isDisabled = true;
              } 
              if (child.name === "Subcon" && !userAccess?.hasSubcon) {
                isDisabled = true;
              } 
              if (child.name === "Agency" && !userAccess?.hasAgency) {
                isDisabled = true;
              } 
              if (child.name === "Payroll Period" && !userAccess?.hasPayrollPeriod) {
                isDisabled = true;
              } 

              return (
                <ul 
                  key={child.link}
                  id={window.location.pathname === child.link ? "active-ul" : ""}
                  onClick={() => window.location.pathname = child.link}
                  style={{display: isDisabled ? "none" : "block"}}
                >
                  <span>- {child.name}</span>
                </ul>
              );
            })}
          </div>
        </div>
  )
  } else if(val.title === "Government Premiums"){
    const govtPath = [
      '/tax',
      '/sss',
      '/pagibig',
      '/philhealth'
    ];
    const isGovtPath = govtPath.includes(window.location.pathname);

    const showSubmenu = (event) => {
      setGovtTabActive(true);
      event.currentTarget.children[1].id = "active-subMenu-govt";
      event.currentTarget.children[0].id = "active-menu-govt";
      SetDropdownIcon(true, "dropdown-icon-govt");
    }
  
    const closeSubmenu = (event) => {
      setGovtTabActive(false);
      event.currentTarget.children[1].id = "";
      event.currentTarget.children[0].id = "";
      SetDropdownIcon(false, "dropdown-icon-govt");
    }

    return(
      !userAccess?.hasBIRTax
      && !userAccess?.hasPagibig 
      && !userAccess?.hasSSS 
      && !userAccess?.hasPhilhealth 
      ?
        <div></div>
      :
        <div 
          onClick={(event)=>(govtTabActive ? closeSubmenu(event) : showSubmenu(event))}>
          <li 
            key={key}
            className="SidebarRow row"
            id={isGovtPath ? "active-menu-govt" : ""}
          > 
            <div id="icon">{val.icon}</div> 
            <div id="title">{val.title}</div>
            <div>
              {isGovtPath ? (
                <KeyboardArrowUpIcon id={"dropdown-icon-govt"} />
              ) : (
                <KeyboardArrowDownIcon id={"dropdown-icon-govt"} />
              )}
            </div>
          </li>
          <div id={isGovtPath ? "active-subMenu-govt" : ""} className="mainte-subMenu" onClick={(event) => event.stopPropagation()}>
          {val.children.map((child) => {
              let isDisabled = false;
              
              if (child.name === "BIR / Tax" && !userAccess?.hasBIRTax) {
                isDisabled = true;
              } 
              if (child.name === "Pagibig" && !userAccess?.hasPagibig) {
                isDisabled = true;
              } 
              if (child.name === "SSS" && !userAccess?.hasSSS) {
                isDisabled = true;
              }
              if (child.name === "Philheath" && !userAccess?.hasPhilhealth) {
                isDisabled = true;
              }

              return (
                <ul 
                  key={child.link}
                  id={window.location.pathname === child.link ? "active-ul" : ""}
                  onClick={() => window.location.pathname = child.link}
                  style={{display: isDisabled ? "none" : "block"}}
                >
                  <span>- {child.name}</span>
                </ul>
              );
            })}
          </div>
        </div>
      )
  } else if(val.title === "Loans & Benefits"){
    const loansPath = [
      '/sssLoan',
      '/sssCalamityLoan',
      '/pagibigLoan',
      '/pagibigCalamityLoan',
      '/cashAdvance',
      '/loans',
      '/deductions',
      '/benefits'
    ];
    
    const isLoanPath = loansPath.includes(window.location.pathname);

    const showSubmenu = (event) => {
      setLoansTabActive(true);
      event.currentTarget.children[1].id = "active-subMenu-loan";
      event.currentTarget.children[0].id = "active-menu-loan";
      SetDropdownIcon(true, "dropdown-icon-loan");
    }
  
    const closeSubmenu = (event) => {
      setLoansTabActive(false);
      event.currentTarget.children[1].id = "";
      event.currentTarget.children[0].id = "";
      SetDropdownIcon(false, "dropdown-icon-loan");
    }

    return(
      !userAccess?.hasSSSLoan
      && !userAccess?.hasSSSCalamityLoan 
      && !userAccess?.hasPagibigLoan 
      && !userAccess?.hasPagibigCalamityLoan 
      && !userAccess?.hasCashAdvance 
      && !userAccess?.hasDeductions 
      && !userAccess?.hasBenefits 
      && !userAccess?.Loans 
      ?
        <div></div>
      :
        <div 
          onClick={(event)=>(loansTabActive ? closeSubmenu(event) : showSubmenu(event))}>
          <li 
            key={key}
            className="SidebarRow row"
            id={isLoanPath ? "active-menu-loan" : ""}
          > 
            <div id="icon">{val.icon}</div> 
            <div id="title">{val.title}</div>
            <div>
              {isLoanPath ? (
                <KeyboardArrowUpIcon id={"dropdown-icon-loan"} />
              ) : (
                <KeyboardArrowDownIcon id={"dropdown-icon-loan"} />
              )}
            </div>
          </li>
          <div id={isLoanPath ? "active-subMenu-loan" : ""} className="mainte-subMenu" onClick={(event) => event.stopPropagation()}>
            {val.children.map((child) => {
              let isDisabled = false;
              
              if (child.name === "SSS Loan" && !userAccess?.hasSSSLoan) {
                isDisabled = true;
              }
              if (child.name === "SSS Calamity Loan" && !userAccess?.hasSSSCalamityLoan) {
                isDisabled = true;
              }
              if (child.name === "Pagibig Loan" && !userAccess?.hasPagibigLoan) {
                isDisabled = true;
              }
              if (child.name === "Pagibig Calamity Loan" && !userAccess?.hasPagibigCalamityLoan) {
                isDisabled = true;
              }
              if (child.name === "Cash Advance" && !userAccess?.hasCashAdvance) {
                isDisabled = true;
              }
              if (child.name === "Loans" && !userAccess?.hasLoans) {
                isDisabled = true;
              }
              if (child.name === "Deductions" && !userAccess?.hasDeductions) {
                isDisabled = true;
              }
              if (child.name === "Benefits" && !userAccess?.hasBenefits) {
                isDisabled = true;
              }

              return (
                <ul 
                  key={child.link}
                  id={window.location.pathname === child.link ? "active-ul" : ""}
                  onClick={() => window.location.pathname = child.link}
                  style={{display: isDisabled ? "none" : "block"}}
                >
                  <span>- {child.name}</span>
                </ul>
              );
            })}
          </div>
        </div>
      )
  } else {
    if(val.title === "Settings" && !userAccess?.hasSettings) {
      return (
        <></>
      );
    }
    if(val.title === "Calendar" && !userAccess?.hasCalendar) {
      return (
        <></>
      );
    }
    if(val.title === "Users" && !userAccess?.hasUser) {
      return (
        <></>
      );
    }

    return (
      <div>
        <li
        key={key}
        className="SidebarRow row"
        id={window.location.pathname === val.link ? "active" : ""}
        onClick={() => {window.location.pathname = val.link}}
        > 
          <div id="icon">{val.icon}</div> 
          <div id="title">{val.title}</div>
        </li>
      </div>
    );
  }
}


function SetDropdownIcon(isMainteActive, id){
  var dropdown = document.getElementById(id)
  if(dropdown !== null){
    if(!isMainteActive){
      dropdown.setAttribute("data-testid", "KeyboardArrowDownIcon");
      dropdown.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`);
    } else {
      dropdown.setAttribute("data-testid", "KeyboardArrowUpIcon");
      dropdown.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`);
    }
  }
}

export default Sidebar